import { takeEvery, call, put } from 'redux-saga/effects';
import {
  sendRequest,
  updateData,
  requestInProcess,
  requestFinished
} from '../../../../../../common/reducers/data/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import FaqContentsService from '../../../../services/FaqContentsService';

function* faqContentsPopularSaga(reducerName) {
  let status = null;
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(timeoutCall, FaqContentsService.getPopular);
    if (result.response) {
      if (result.response.status === 200) {
        yield put(updateData(reducerName, result.destructData));
      }
    }
    status = result.response.status;
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      faqContentsPopularSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/reducers/static/objects/sagas/faqContentsPopularSaga.js